import { Id, toast } from 'react-toastify';

export const toastAlert = () => {
  let toastId: Id;

  return {
    info: ({ title }: { title: string }) => {
      toastId = toast(title, {
        position: 'top-right',
        autoClose: false,
      });
    },

    success: ({ title }: { title: string }) => {
      toastId = toast(title, {
        position: 'top-right',
        autoClose: 2000,
      });
    },

    error: ({ title }: { title: string }) => {
      toastId = toast.error(title, {
        position: 'top-right',
        autoClose: 2000,
      });
    },

    close: () => (toastId ? toast.dismiss(toastId) : {}),
  };
};